import {useGetActivitiesForWidget} from '../graphql/hooks/use-get-activities-for-widget';

export function useGetScheduledActivitiesCount(entityId: string): string | undefined {
    const {activities: scheduledActivities} = useGetActivitiesForWidget(entityId, 0);

    return scheduledActivities && scheduledActivities.length
        ? `${scheduledActivities.length}`
        : undefined;
}
